import type { PublicSlotKey } from '#packages/apilib';
import type { DesignerPanelsApi } from './designerPanelsApi';

export const DesignerPanelsApiKey: PublicSlotKey<DesignerPanelsApi> = {
  name: 'DesignerPanelsApi',
  public: true,
};
